export default {
    placeholder: 'O que você está procurando?',
    search: 'Buscar',
    foundItems: '{count, plural, one {Encontramos # artigo} other {Encontramos # artigos}} para "{query}"',
    notFound: 'Nenhum artigo encontrado.',
    error: 'Ops! Algo deu errado na busca.',
    tryAgain: 'Tentar novamente',
};
